const STORAGE_KEY = "posCustomerDisplayCustomer";
const EVENT_NAME = "customer-display-customer-updated";

export type CustomerDisplayCustomer = {
  displayName: string;
  loyaltyPointsBalance: number | null;
};

export function getCustomerDisplayCustomer(): CustomerDisplayCustomer | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CustomerDisplayCustomer;
    if (
      typeof parsed?.displayName === "string" &&
      (parsed.loyaltyPointsBalance === null ||
        typeof parsed.loyaltyPointsBalance === "number")
    ) {
      return parsed;
    }
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }
  return null;
}

export function setCustomerDisplayCustomer(data: CustomerDisplayCustomer): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function clearCustomerDisplayCustomer(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function addCustomerDisplayCustomerListener(
  callback: () => void,
): () => void {
  const handler = () => callback();
  const storageHandler = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) callback();
  };
  window.addEventListener(EVENT_NAME, handler);
  window.addEventListener("storage", storageHandler);
  return () => {
    window.removeEventListener(EVENT_NAME, handler);
    window.removeEventListener("storage", storageHandler);
  };
}
